import styled, { css } from 'styled-components';
import {
  styled as muiStyled,
  Button,
  Stack,
  Typography,
  FormControl,
} from '@mui/material';

import { COLORS } from '../../../../../../themes/colors';

const commonBTN = css`
  font-size: 13px;
  padding: 4px 10px;
  letter-spacing: 0.46px;
  line-height: 22px;
  border-radius: 4px;
  text-transform: capitalize;
`;

export const FormWrapper = muiStyled(FormControl)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const ContentWrapper = styled.div`
  padding: 0 16px;
`;


export const LabelContent = muiStyled(Stack)(() => ({
  flexDirection: 'row',
  padding: '0 16px',
  marginBottom: 16,
}));

export const Label = muiStyled(Typography)(() => ({
  fontFamily: 'Work Sans',
  fontStyle: 'normal',
  fontSize: '16px',
  letterSpacing: '0.1px',
  color: `${COLORS.DARK['+5']}`,
}));

export const ActionBar = muiStyled(Stack)(props => ({
  flexDirection: 'row',
  justifyContent: props.dontShowClearButton ? 'flex-end' : 'space-between',
  alignItems: 'center',
  padding: '8px 8px 0',
  gap: '8px',
}));

export const SubmitButton = muiStyled(Button)(() => ({
  commonBTN,
  fontFamily: 'Work Sans',
  backgroundColor: `${COLORS.PRIMARY.BLUE.MAIN}`,
  color: `${COLORS.WHITE}`,
  boxShadow: `0px 3px 1px -2px ${COLORS.DARK['-2']}, 0px 2px 2px ${COLORS.DARK['-6']}, 0px 1px 5px ${COLORS.DARK['-7']}`,
  ':hover': {
    backgroundColor: `${COLORS.PRIMARY.BLUE.MAIN}`,
    filter: 'brightness(0.85)',
  },
  flex: 1,
  textTransform: 'uppercase'
}));

export const ClearButton = muiStyled(Button)(() => ({
  commonBTN,
  fontFamily: 'Work Sans',
  backgroundColor: 'none',
  color: `${COLORS.PRIMARY.BLUE['-4']}`,
  boxShadow: 'none',
  ':hover': {
    backgroundColor: 'none',
    filter: 'brightness(0.85)',
  },
  flex: 1,
  textTransform: 'uppercase'
}));
